import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import navLinks from '../../constants/navigation';
import appInfo from '../../constants/appInfo';
import logoMark from '../../images/logo-mark.png';
import logoName from '../../images/logo-name.png';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleNavClick = (href) => {
    setActiveLink(href);
    setMenuOpen(false);
    if (isHome && href.startsWith('#')) {
      const id = href.slice(1);
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <nav className="navbar__inner container">

        <Link to="/" className="navbar__logo">
          <div className="navbar__logo-mark" aria-hidden="true">
            <img
              src={logoMark}
              alt="Dhenika logo"
              width="40"
              height="40"
              style={{ objectFit: 'contain' }}
            />
          </div>
          {/*
            FIX: removed the inline height="22" here.
            It was being overridden by the CSS class .navbar__logo-name
            (which had height: 60px), causing the huge logo text.
            Sizing is now controlled entirely by the CSS class below.
          */}
          <img
            src={logoName}
            alt="Dhenika"
            className="navbar__logo-name"
          />
        </Link>

        <ul className="navbar__links">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={isHome ? link.href : `/${link.href}`}
                className={`navbar__link ${activeLink === link.href ? 'navbar__link--active' : ''}`}
                onClick={() => handleNavClick(link.href)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href={appInfo.playStoreUrl}
          className="navbar__cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Free
        </a>

        <button
          className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

      </nav>

      {menuOpen && (
        <div className="navbar__mobile navbar__mobile--open">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={isHome ? link.href : `/${link.href}`}
              className="navbar__mobile-link"
              onClick={() => handleNavClick(link.href)}
            >
              {link.label}
            </a>
          ))}
          <a
            href={appInfo.playStoreUrl}
            className="navbar__mobile-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Free
          </a>
        </div>
      )}

    </header>
  );
}

export default Navbar;